import React from "react";
import { getTitleForFAQ } from "../../../../../shared/config/utils";
import * as S from "./HomeFaq.styles";

interface faqProps {
  faqData: Array<props>;
  rf: string,
  cabsFaqData: Array<{question: string, answer: string}>
}

interface props {
  ans: string;
  ques: string;
}

const HomeBookingFaq: React.FC<faqProps> = ({ faqData,rf,cabsFaqData }) => {
  if (!(faqData?.length || cabsFaqData?.length)) return null;
  return (
    <S.Wrapper itemScope itemType="https://schema.org/FAQPage">
      <h2>{getTitleForFAQ(rf)}</h2>
      <S.ContentWrapper>
        <ul>
          {faqData?.length ? (
            <>
              {faqData?.map(({ ans = '', ques = '' }, index) => (
                <li key={`Route${index}`} itemProp="mainEntity" itemScope itemType="https://schema.org/Question">
                <S.Question>
                  <h3 itemProp="name">{ques}</h3>
                </S.Question>
                <S.Answer itemProp="acceptedAnswer" itemScope itemType="https://schema.org/Answer">
                  <div itemProp="text" dangerouslySetInnerHTML={{ __html: ans }} />
                </S.Answer>
              </li>
              ))}
            </>
          ) : null}
          {cabsFaqData?.length ? (
            <>
              {cabsFaqData?.map(({ question = '', answer = '' }, index) => (
                <li key={`Route${index}`} itemProp="mainEntity" itemScope itemType="https://schema.org/Question">
                <S.Question>
                  <h3 itemProp="name">{question}</h3>
                </S.Question>
                <S.Answer itemProp="acceptedAnswer" itemScope itemType="https://schema.org/Answer">
                  <p itemProp="text" dangerouslySetInnerHTML={{ __html: answer }} />
                </S.Answer>
              </li>
              ))}
            </>
          ) : null}
        </ul>
      </S.ContentWrapper>
    </S.Wrapper>
  );
};
export default HomeBookingFaq;
